import React from 'react';

export function CompanyFinancing() {
  return <>Company Financing</>;
}
